'use strict';

var _regeneratorRuntime = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

var _wrapAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncGeneratorDelegate");

var _asyncIterator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var CID = require('cids');

var configure = require('../lib/configure');

var normaliseInput = require('ipfs-core-utils/src/pins/normalise-input');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api) {
  return (
    /*#__PURE__*/
    function () {
      var _rmAll = _wrapAsyncGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(source) {
        var options,
            _iteratorNormalCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            _value,
            _value3,
            path,
            recursive,
            searchParams,
            res,
            _iteratorNormalCompletion2,
            _didIteratorError2,
            _iteratorError2,
            _iterator2,
            _step2,
            _value2,
            pin,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                options = options || {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 4;
                _iterator = _asyncIterator(normaliseInput(source));

              case 6:
                _context.next = 8;
                return _awaitAsyncGenerator(_iterator.next());

              case 8:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 12;
                return _awaitAsyncGenerator(_step.value);

              case 12:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 61;
                  break;
                }

                _value3 = _value, path = _value3.path, recursive = _value3.recursive;
                searchParams = new URLSearchParams(options.searchParams);
                searchParams.append('arg', "".concat(path));
                if (recursive != null) searchParams.set('recursive', recursive);
                _context.next = 20;
                return _awaitAsyncGenerator(api.post('pin/rm', {
                  timeout: options.timeout,
                  signal: options.signal,
                  headers: options.headers,
                  searchParams: toUrlSearchParams(_objectSpread({}, options, {
                    arg: "".concat(path),
                    recursive: recursive
                  }))
                }));

              case 20:
                res = _context.sent;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _context.prev = 23;
                _iterator2 = _asyncIterator(res.ndjson());

              case 25:
                _context.next = 27;
                return _awaitAsyncGenerator(_iterator2.next());

              case 27:
                _step2 = _context.sent;
                _iteratorNormalCompletion2 = _step2.done;
                _context.next = 31;
                return _awaitAsyncGenerator(_step2.value);

              case 31:
                _value2 = _context.sent;

                if (_iteratorNormalCompletion2) {
                  _context.next = 42;
                  break;
                }

                pin = _value2;

                if (!pin.Pins) {
                  _context.next = 37;
                  break;
                }

                return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(pin.Pins.map(function (cid) {
                  return new CID(cid);
                })), _awaitAsyncGenerator), "t0", 36);

              case 36:
                return _context.abrupt("continue", 39);

              case 37:
                _context.next = 39;
                return new CID(pin);

              case 39:
                _iteratorNormalCompletion2 = true;
                _context.next = 25;
                break;

              case 42:
                _context.next = 48;
                break;

              case 44:
                _context.prev = 44;
                _context.t1 = _context["catch"](23);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 48:
                _context.prev = 48;
                _context.prev = 49;

                if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                  _context.next = 53;
                  break;
                }

                _context.next = 53;
                return _awaitAsyncGenerator(_iterator2.return());

              case 53:
                _context.prev = 53;

                if (!_didIteratorError2) {
                  _context.next = 56;
                  break;
                }

                throw _iteratorError2;

              case 56:
                return _context.finish(53);

              case 57:
                return _context.finish(48);

              case 58:
                _iteratorNormalCompletion = true;
                _context.next = 6;
                break;

              case 61:
                _context.next = 67;
                break;

              case 63:
                _context.prev = 63;
                _context.t2 = _context["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context.t2;

              case 67:
                _context.prev = 67;
                _context.prev = 68;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 72;
                  break;
                }

                _context.next = 72;
                return _awaitAsyncGenerator(_iterator.return());

              case 72:
                _context.prev = 72;

                if (!_didIteratorError) {
                  _context.next = 75;
                  break;
                }

                throw _iteratorError;

              case 75:
                return _context.finish(72);

              case 76:
                return _context.finish(67);

              case 77:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 63, 67, 77], [23, 44, 48, 58], [49,, 53, 57], [68,, 72, 76]]);
      }));

      function rmAll(_x) {
        return _rmAll.apply(this, arguments);
      }

      return rmAll;
    }()
  );
});